var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFiltersMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 -0.5H9V1.5H-2V3.5H9V4.5H11V-0.5Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.5H18V3.5H13V1.5Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5V9.5H-2V7.5H2V5.5H4V10.5H2Z",
    fill: "#191919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5H-2V15.5H16V16.5H18V11.5H16V13.5Z",
    fill: "#191919"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5H6V9.5H18V7.5Z",
    fill: "#191919"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiltersMobile);
export default __webpack_public_path__ + "static/media/iconFiltersMobile.7213f9d3d475323e46b3890870ae05dc.svg";
export { ForwardRef as ReactComponent };